var MotoSelection = (function ($, MotoSearchJs) {

    function onSelectMotorcycle() {
        $(".moto-selection-form-error").hide();
        var formData = $(".moto-selection-form").serializeArray();
        var payload = {};
        $(formData).each(function (index, element) {
            payload[element.name] = element.value;
        });

        $.ajax({
            url: "/motorcycle/selection",
            type: "POST",
            data: JSON.stringify(payload),
            headers: {
                "X-CSRF-TOKEN": $("._csrf").val()
            },
            contentType: "application/json",
            cache: false
        }).done(function () {
            $(".moto-selection-form-container").hide();
            $(".fancybox-close").hide();
            $(".moto-selection-form-container-success").show();
            setTimeout(function () {
                var link = window.location.pathname;
                link += '#set-offers-tab';
                window.location.href = link;
                location.reload();
            }, 2000);

        }).fail(function () {
            $(".moto-selection-form-error").show();
        });
    }

    function onLoadMotorcycleSelectionForm(form) {
        $.fancybox({
            width: 360,
            height: 'auto',
            content: form,
            fitToView: true,
            autoSize: false,
            helpers: {
                overlay: {
                    locked: false
                }
            }
        });

        MotoSearchJs.addHandlers();
        MotoSearchJs.initDropdowns();
        $(".moto-selection-form-submit-button").on('click', onSelectMotorcycle);
    }

    function onClickSelectMotorcycleLink() {
        $.ajax({
            url: "/motorcycle/selection/form",
            type: "GET",
            cache: false
        }).done(onLoadMotorcycleSelectionForm);
    }

    function initialize() {
        $(".motorcycle-selection-link").on('click', onClickSelectMotorcycleLink);
    }

    return {
        initialize: initialize
    }
})($, MotoSearchJs);

$(function () {
    MotoSelection.initialize();
});